export default __webpack_public_path__ + "static/media/Proposal.b507c36c.svg";